export const MuiTextField = (palette) => {
    return {
        root: {
            '& .MuiFormHelperText-contained': { margin: '4px 0 0 0' },
            '& .MuiFormHelperText-contained &&:not(.Mui-error)': { color: palette.semantic.colorForegroundDeEmp },
            '&.MuiFormHelperText-root .Mui-error': { color: palette.semantic.colorErrorText },
            '& .MuiInputLabel-root': {
                transform: 'none',
                position: 'relative',
            },
        },
    };
};
